import {
  getAllCoursesHttp,
  addCourseHttp,
  updateCourseHttp,
  deleteCourseHttp,
  fetchAllCoursesDG2Http,
  getCountHttp,
  getAllPagincationCoursesHttp,
} from "../../services/planning/CourseServices.js";
import i18n from "@/i18n";

const state = {
  courses: [],
  totalItemCount: null,
};

const getters = {
  getCourses(state) {
    return state.courses;
  },
  getTotalItemCount(state) {
    return state.totalItemCount;
  },
};

const mutations = {
  SET_COURSES: (state, data) => (state.courses = data),
  ADD_NEW_COURSE: (state, payload) => state.courses.push(payload),
  EDIT_COURSE: (state, payload) => {
    let index = state.courses.findIndex((l) => l.id === payload.id);
    if (index !== -1) state.courses.splice(index, 1, payload);
  },
  REMOVE_COURSE: (state, payload) => {
    let index = state.courses.findIndex((l) => l.id === payload);
    if (index !== -1) state.courses.splice(index, 1);
  },
  SET_ITEM_COUNT: (state, data) => (state.totalItemCount = data),
};

const actions = {
  /**
   * This method will load all courses from the database
   *
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_COURSES", response.data)
   */
  async loadCourses({ commit, dispatch }) {
    await getAllCoursesHttp()
      .then((response) => commit("SET_COURSES", response.data))
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.courseAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method will load courses depending of page, size and search parameters
   *
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {int} {page page number that will be load
   * @param  {int} size number of courses that will be load (represents LIMIT in sql)
   * @param  {String} search} only courses containing 'search' will be load
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_COURSES", response.data)
   */
  async loadPaginationCourses({ commit, dispatch }, { page, size, search }) {
    await getAllPagincationCoursesHttp(page, size, search)
      .then((response) => commit("SET_COURSES", response.data))
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.courseAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method will give the number of courses containing 'search'
   *
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {String} {search} only courses containing 'search' will be counted
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_ITEM_COUNT", response.data.nb)
   */
  async getCount({ commit, dispatch }, { search }) {
    await getCountHttp(search)
      .then((response) => {
        commit("SET_ITEM_COUNT", response.data.nb);
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.courseAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to add a course in the database and then in the VueX store
   *
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {Object - courseDto} course object that we want to add in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("ADD_NEW_COURSE", response.data)
   */
  async addCourse({ commit, dispatch }, course) {
    await addCourseHttp(course)
      .then((response) => {
        commit("ADD_NEW_COURSE", response.data);
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.courseAddSuccess"),
            typeAlert: "success",
          },
          { root: true } // root true in order to access to methods from a different module
        );
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.courseAddError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to edit a course in the database and then in the VueX store
   *
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {Object - courseDto} course object that we want to edit in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("EDIT_COURSE", response.data)
   */
  async editCourse({ commit, dispatch }, course) {
    await updateCourseHttp(course)
      .then((response) => {
        commit("EDIT_COURSE", response.data),
          dispatch(
            "notificationModule/showNotification",
            {
              messageAlert: i18n.t("messageStores.courseEditSuccess"),
              typeAlert: "success",
            },
            { root: true }
          );
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.courseEditError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to delete a course in the database and then in the VueX store
   *
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {Object - courseDto} course object that we want to delete in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("REMOVE_COURSE", course.id)
   */
  async deleteCourse({ commit, dispatch }, course) {
    await deleteCourseHttp(course.id)
      .then((response) => {
        if (response.status === 202) {
          commit("REMOVE_COURSE", course.id),
            dispatch(
              "notificationModule/showNotification",
              {
                messageAlert: i18n.t("messageStores.courseDeleteSuccess"),
                typeAlert: "success",
              },
              { root: true }
            );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.courseDeleteError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to fetch courses from the webservice Wdg2 (create or update depending if the course exists or not)
   *
   * @param  {vueX} {dispatch} necessary if call dispatch inside the method
   * @param  {Object - LogInUser} logInUser user dg2
   * @returns {} it is returning nothing. The database is updated directly in the Back-End when the method is called.
   */
  async fetchCoursesDG2({ dispatch }, { logInUser }) {
    await fetchAllCoursesDG2Http(logInUser)
      .then((response) => {
        if (response.status === 202) {
          dispatch(
            "notificationModule/showNotification",
            {
              messageAlert: i18n.t("messageStores.courseAllSuccess"),
              typeAlert: "success",
            },
            { root: true }
          );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.courseAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
